export default "__VITE_ASSET__advME1rS__"